// extracted by mini-css-extract-plugin
module.exports = {"live":"LiveBadge_live__3cy0P","indicator":"LiveBadge_indicator__2FWCi","pulse":"LiveBadge_pulse__2YtWn","text":"LiveBadge_text__1ycdP"};